<template>
  <select v-model="selected" class="form-select mt-4 block w-full border p-3 rounded" @change="onChange">
      <option value="0" selected>Select Country</option>
      <option v-for="country in countries" :value="country.ID" :key="country.ID">{{country.Country}}</option>
  </select>
</template>

<script>
import { ref } from 'vue';

export default {
    name:'CountrySelect',
    props:['countries'],
    data(){
        return{
            selected:0,
        }
    },
    methods:{
        onChange(){
            //console.log(this.countries);
            const country = this.countries.find((item) => item.ID === this.selected);
            //console.log("🚀 ~ file: CountrySelect.vue ~ line 20 ~ onChange ~ country", country)
            this.$emit('get-country', country);
        }
    }
}
</script>
